import { CtaButton } from "../Button/CtaButton";
import { StarRatingValue } from "../StarRatingValue";
import s from "./style.module.scss";
import { scrollToComponent } from "../../utils/helpers.ts";

type CtaButtonProps = {
  text: string;
  reviewslabel: string;
  reviewsCount: string;
  starsRating: string;
};

export const CtaWithReviews = ({
  text,
  starsRating,
  reviewsCount,
  reviewslabel,
}: CtaButtonProps) => (
  <div className={s.buttonWithReviews}>
    <CtaButton text={text} onClick={() => scrollToComponent("products")} />
    <div className={s.buttonWithReviews__rating}>
      <StarRatingValue rating={starsRating} />
      <div className={s.buttonWithReviews__ratingNumber}>{starsRating}</div>
      <div className={s.buttonWithReviews__ratingSeparator}>|</div>
      <div
        className={s.buttonWithReviews__reviewsNumber}
      >{`${reviewsCount} ${reviewslabel}`}</div>
    </div>
  </div>
);
